import React from 'react';
import CustomSelectField from '../../../../common/CustomSelectField';
import { setPatientData } from '../../../../actions';
import { useDispatch, useSelector } from 'react-redux';
export default function EtTypes() {
  const dispatch = useDispatch();
  const patientData = useSelector((state) => state.clinicalReducer);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(setPatientData(`currentCycle.fetSheet.${name}`, value));
  };
  return (
    <div div className="theme-blush">
      <div className="container-fluid">
        <div className="card">
          <div className="body">
            <div className="card_name_container" style={{maxWidth: 300}}>
              <CustomSelectField
                label="Types of ET"
                name="typesOfET"
                value={patientData.currentCycle.fetSheet.typesOfET}
                options={['Fresh', 'Frozen']}
                // otherValue={patientData.patientHistory.fms.typesOfETOther}
                onChange={handleInputChange}
                isOtherValue={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
